module.exports = __webpack_public_path__ + "img/9788983944917.adb57ace.jpg";